<div class="bo-user-modal">
    <div class="modal-title">Adauga utilizator</div>

    <form [formGroup]="form">
        <div class="form-group">
            <div class="form-control">
                <mat-form-field>
                    <mat-label>Nume si prenume</mat-label>
                    <input matInput type="text" formControlName="fullName" placeholder="Andrei Popescu">
                </mat-form-field>
            </div>
        </div>
        <div class="form-group">
            <div class="form-control">
                <mat-form-field>
                    <mat-label>Adresa de email</mat-label>
                    <input matInput type="text" formControlName="email" placeholder="andrei.popescu@mobilize-fs.com">
                </mat-form-field>
            </div>
        </div>
        <div class="form-group">
            <div class="form-control">
                <mat-form-field>
                    <mat-label>Rol</mat-label>
                    <input matInput type="text" formControlName="role">
                </mat-form-field>
            </div>
        </div>
        <div class="form-actions">
            <button class="mobilize-btn btn-orange" (click)="createUser()">Activeaza</button>
            <button class="mobilize-btn btn-clear" (click)="closeModal()">Cancel</button>
        </div>
    </form>
</div>
